<template>
  <el-drawer
    :title="title"
    :visible.sync="show"
    :direction="direction"
    :destroy-on-close="destroyOnClose"
    :show-close="showClose"
    :close-on-press-escape="showClose"
    :wrapper-closable="showClose"
    :size="width"
    @close="close"
  >
    <template #title>
      <div v-if="!showClose" class="drawer-header">
        <div class="header-left">{{ title }}</div>
        <div class="header-right">
          <el-button
            type="primary"
            size="mini"
            :loading="loading"
            @click="handleConfrim"
            >提交</el-button
          >
          <el-button type="info" size="mini" @click="handleCancel"
            >取消</el-button
          >
        </div>
      </div>
    </template>
    <div class="drawer-body" v-loading="loading">
      <slot></slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'BaseDrawer',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    direction: {
      type: String,
      default: 'rtl',
    },
    // 重新打开是否销毁子元素
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
    // 抽屉宽度
    width: {
      type: String,
      default: '40%',
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // 弹框标题
    title: {
      type: String,
      default: '标题',
    },
  },
  data() {
    return {
      loading: false,
      show: false
    };
  },
  watch: {
    visible: {
      handler() {
        this.show = this.visible
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    // 点击取消
    handleCancel() {
      this.$emit('update:visible', false);
    },
    // 点击提交
    async handleConfrim() {
      const res = await this.$confirm('是否确认提交？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {});
      if (res === 'confirm') {
        this.loading = true;
        this.$emit('confirm', () => {
          this.loading = false;
        });
      }
    },
    close() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer__header {
  color: #333;
  font-weight: bolder;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 0;
}
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 1px solid #eee;
  // padding-bottom: 10px;
  .header-left {
    font-size: 16px;
    font-weight: bolder;
    color: #333;
  }
}
.drawer-body {
  padding: 30px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
